import React from 'react'
import { Link } from 'react-router'
import URLS from '../../../configurations/urls';
import ATable from "../../common/table";



const  BulkUpdateStatusTable = (props) => {
  const { tableData, loading, onRowClick, onTableChange, paginatedCallBack } = props;

  
  const columns = [
    // {
    //   header: () => <div>
    //     <label>
    //     <input
    //       type="checkbox"
    //       onChange={() => toggleSelection(null, "toggle-all")}
    //     />
    //     <span
    //       className="lbl"
    //       checked={selectAll}
    //     >
          
    //     </span>
    //     </label>
    //   </div>,
    //   id: "checkbox",
    //   render: row => (<div>
    //     <label>
    //       <input
    //         type="checkbox"
    //         onChange={() => toggleSelection(row.row.logCode, null)}
    //         checked={selection.includes(row.row.logCode)}
    //       />
    //       <span
    //         className="lbl"
    //         defaultChecked={selection.includes(row.row.logCode)}
    //       >
    //       </span>
    //     </label>
    // </div>),
    //   width: 35,
    //   sortable: false
    // },
    {
      header: "S/N",
      id: "s-n",
      render: row => <div>{paginatedCallBack(row.viewIndex)}</div>,
      width: 50
    },
    {
      header: "Domain",
      accessor: "domain",
      width: 100
    },
    {
      header: "Dispute Category",
      accessor: "disputeCategory",
      width: 130
    },
    {
      header: "Dispute Action",
      accessor: "disputeAction",
      width: 130
    },
    {
      header: "Records",
      accessor: "recordCount",
      width: 130
    },
    {
      header: "Processed",
      accessor: "processedCount",
      width: 130
    },
    {
      header: "Error",
      accessor: "errorCount",
      width: 130
    },
    {
      header: "Status",
      accessor: "status",
      width: 130
    },
    {
      header: "Created By",
      accessor: "createdBy",
      width: 130
    },
    {
      header: "Created On",
      accessor: "createdOn",
      width: 130
    },
    {
      header: "Output File",
      accessor: "outputFile",
      render: row => {
        return (<Link to={{ pathname: `${window.location.origin}${URLS.ARBITER_BASE_PATH}${URLS.ARBITER_API_BASE_PATH}/${URLS.ARBITER_API_DISPUTES_BULK_ACCEPT_OR_DECLINE}/files/${row.row.outputFile}` }} target="_blank">{`${row.row.outputFile}`}</Link>);
      },
      width: 130
    }
  ];

    return (
      <div>
        <div>
          <ATable
            className="-striped -highlight"
            tableData={tableData}
            columns={columns}
            loading={loading}
            onRowClick={onRowClick}
            onChange={onTableChange || null}
            manual
            {...props}
          />
        </div>
      </div>
      
    );
  }

export default BulkUpdateStatusTable;



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/bulk_update_status/BulkUpdateStatusTable.js